export default __webpack_public_path__ + "static/15_36-3a73e4669d7935a895eefb778cbb0013.png";